import { Asset } from "../Pages/AssetPage";

// Bar chart data types
export interface BarItem extends Record<string, any> {
    category: string;
    value: number;
  }
  
  export interface SubBarItem extends Record<string, any> {
    subcategory: string;
    value: number;
  }
  
  export interface DrillDownData {
    'Head Protection': SubBarItem[];
    'Hand Protection': SubBarItem[];
    'Foot Protection': SubBarItem[];
    'Fall Protection': SubBarItem[];
    Tools: SubBarItem[];
  }
  
  // Line chart data types
  export interface LinePoint {
    x: string;
    y: number;
  }
  
  export interface LineData {
    id: string;
    data: LinePoint[];
  }

  export const USER_ROLE = {
  ADMIN_ABATIX: 1,
  CUSTOMER_STAFF: 2,
  CUSTOMER_ADMIN: 3,
};

  
  // Pie chart data types
  export interface PieData {
    id: string;
    label: string;
    value: number;
    color: string;
  }

  export interface GpsPoint {
    id: number;
    name: string;
    device_id: string;
    imei: string;
    voltage: number | null;
    latitude: number;
    longitude: number;
    timestamp: string;
  }

  export interface GpsDevicePoint {
  id: number;
  device_id: string;
  name: string;
  voltage: string | number;
  gnss_run_status: number;
  fix_status: number;
  utc_datetime: string; 
  latitude: string;
  longitude: string;
  altitude: number | null;
  speed_over_ground: number | null;
  course_over_ground: number | null;
  fix_mode: number;
  hdop: number | null;
  pdop: number | null;
  vdop: number | null;
  satellites_in_view: number;
  cn0_max: number | null;
  hpa: string;
  recorded_at: string;
}


export interface AssetTransaction {
    id: number;
  asset_id: number;
  OVID: number;
  checkout_user_id: number;
  checkin_user_id: number | null;
  checkout_datetime: string; 
  checkin_datetime: string | null; 
  note: string | null;
  is_active: number;
  created_at: string; 
  updated_at: string; 
  po_number: string | null;
  issued_bin_location: string | null;
  returned_bin_location: string | null;
  checkout_requester_user_id: number | null;
  checkin_requester_user_id: number | null;
  transaction_number: string | null;
  name: string;
  serial_number: string;
}


  export interface InventoryData {
    product_id: string;   // From abatix_inventory
    product_code: string;   // From abatix_inventory
    pid: string;          // From products (same as product_id, but included for clarity)
    description?: string; // From products; optional if not always present
    quantity?: number;    // From abatix_inventory; optional if not in your table
    cancelled_flag?: string; // From abatix_inventory; optional since filtered to 'N'
  }


  export interface Company {
    CID: number;
    name: string;
    IsActive: boolean;
    P21CustomerID: string;
    IsAutoInvoice: boolean;
    IsConsolidatedInvoice: boolean;
    IsP21Company: boolean;
    IsDemoAccount: boolean;
    IsTrustedCustomer: boolean;
    CreatedDate?: string;
    ModifiedDate: string;
    PriceVisibleFlag: boolean;
    SpendingLimitEnableFlag: boolean;
    ParentCompanyID: number;
    OrganizationID: string;
    BillingDay: number;
    BillingTime: number;
    ModifiedBy: number;
  }
  

  export interface CompanyFormInput {
    name: string;
    P21CustomerID: string;
    IsActive: boolean;
    IsAutoInvoice: boolean;
    IsConsolidatedInvoice: boolean;
    IsP21Company: boolean;
    IsDemoAccount: boolean;
    IsTrustedCustomer: boolean;
    PriceVisibleFlag: boolean;
    SpendingLimitEnableFlag: boolean;
    ParentCompanyID?: number;
    OrganizationID: string;
    BillingDay?:  number;
    BillingTime?:  number;
  }
  

  export interface GpsDevice {
  id: number;
  device_id: string;
  name: string | null;
  voltage: number;
  gnss_run_status: number;
  fix_status: number;
  utc_datetime: string;
  latitude: number;
  longitude: number;
  altitude: number;
  speed_over_ground: number;
  course_over_ground: number;
  fix_mode: number;
  hdop: number;
  pdop: number;
  vdop: number;
  satellites_in_view: number;
  cn0_max: number;
  hpa: number;
  recorded_at: string;
}

export interface GpsDeviceCompany{
  id: number;
  device_id: string;
  name: string | null;
  asset_id: number;
  company_id: string;
}



  export interface Location {
    OVID: number;
    OVCODE: string;
    name: string;
    CID: string;
    longitude: number;
    latitude: number;
    CustomerName: string;
    CustomerId: string;
    ShipToId: string;
    ContractJobNumber: string;
    SaleLocationId: string;
    CreatedDate?: string;
    CreatedBy: number;
    ModifiedDate: string;
    ModifiedBy: number;
    IsActive: boolean;
    LocationTypeId: number;
    p21_nc_post_order_flag: boolean;
    p21_nc_auto_order_approval_flag: boolean;
    binlocation_flag: boolean;
    p21_nc_post_quote_flag: boolean
  }

  export interface User {
    ID: number;
    RFID: string
    username: string;
    first_name: string;
    last_name: string;
    contact_number: string;
    user_type?: number;
    password: string;
    image: string;
    email: string;
    IsActive: boolean;
    password_reset_url: string;
    IsConsumed: boolean;
    FullControl: boolean;
    IsEditable: boolean;
    post_order_for_worker_flag: boolean;
    role_id?: number;
    OVID?: number;
    COMPANYID?: number;
}

export interface Report {
  ID: number;
  UserId: number;
  UserName?: string;
  ProductName?:string;
  PID: number;
  Product_code: string;   
  PreviousQty: number;
  UpdatedQty: number;
  MinimumQty: number;
  MaximumQty: number;
  Created_At: string;
  VendingLocationId: number;
  CustomerName?: string | null;
  VendingLocationName?: string | null;
  Note: string;
  NotSyncOrderQty: number;
  P21OrderNumber: string;
  P21InvoiceNumber: string;
  ModifiedDate: string;
  Key1CD: string;
  Key1Value: string;
  Key2CD: string;
  Key2Value: string;
  Key3CD: string;
  Key3Value: string;
}


export interface AssetCategory {
  id: number;
  category_id: number;
  category_name: string;
  description: string;
  image: string | null;
  active_flag: number;
  created_at: string;
  updated_at: string; 
  customer_id: number;
  location_id: number | null;
  created_by: number;
  customer_name: string;
  location_name: string;
}


export interface Role {
  id: number;
  name: string;
  level: number;
  description: string;
}


export interface Kit {
    id?: number;
    kit_id: number;
    user_id: number;
    name: string;
    description: string;
    OVID: string;
    created_date: string;
    active_flag: number
    assets?: Asset[];
}




export interface NonAbatixCategory {
  category_id: number;
  category_name: string;
  category_code: string | null;
  customer_id: number;
  active_flag: number;
  modified_date: string | null;
  modified_by: number | null;
  customer_name: string;
  location_name: string | null;
  location_ids?: number[];
  location_count?: number;
  total_location_count?: number;
  description: string | null;
  full_name: string | null;
}

export interface BinLocation {
  bin_location_id: number;
  bin_location_name: string;
  ailse: string;
  rack: string | null;
  shelf: string | null;
  bin: string | null;
  active_flag: number;
  deleted_flag: number; 
  created_date: string; 
  modified_date: string; 
  customer_id: number;
  vending_location_id: number;
  vending_location_name: string;
  customer_name: string;
}